import { BASE_URL, PROVIDER_ID } from './../config/index';

export const GET_CLAIMANTS = (policies, webFormData) => {
  let returnedValue =  Object.values(policies).map((policy, index) => {
    let exist = false;
    webFormData.data.policies.forEach(webformPolicy => {
      if(webformPolicy.policyId == policy.id){
        exist = true
      }
    });
    if(exist){
      return { id:policy.id, value: policy.additionalRegistrationFields[0].label };
    } else {
      return null;
    }
  });
  
  
  return returnedValue.filter((entry) => entry !== null);
};

export const GET_EXTRA_FIELD = (policies) => {
  return Object.values(policies).map((policy, index) => {
    return { id:policy.id, fieldObj: policy.additionalRegistrationFields[1]};
  });
};

export const SEND_POST_REQUEST = (data, endpoint, json = true) => {
  const payload = json ? JSON.stringify(data) : new URLSearchParams(data);
  return fetch(BASE_URL + endpoint, {
    method: 'POST',
    headers: json === true ? {
      'Content-Type': 'application/json;charset=UTF-8',
      'x-app-version': 2,
      'x-provider-id': PROVIDER_ID }
    : {},
    body: payload
  });
};

export const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
  });
};